<wr-base-dialog status="danger"
                header="Gebäudeantrag ablehnen"
                [submitResponse]="submitAction"
                [disableSubmit]="!rejectComment().trim()"
                submitText="Ablehnen">

  <div class="dialog-content">
    <div class="error-message" *ngIf="!rejectComment().trim()">
      Ein Grund für die Ablehnung ist erforderlich.
    </div>

    <div class="input-group">
      <label class="label" for="rejectComment">Grund der Ablehnung</label>
      <textarea
        id="rejectComment"
        nbInput
        fullWidth
        rows="5"
       

        placeholder="Geben Sie hier den Grund an..."
        [ngModel]="rejectComment()"
        (ngModelChange)="rejectComment.set($event)"
        [status]="!rejectComment().trim() ? 'danger' : 'basic'">
      </textarea>
    </div>
  </div>

</wr-base-dialog>
